import React from "react";

export function checkParams(id) {
  if (!id) {
    location.replace("/integrators/list");
  }
}

export function renderApiList(list) {
  return list.map((api, i) => (
    <p
      style={{ height: "45px", textOverflow: "ellipsis", overflow: "hidden" }}
      key={api.name}
    >{`${i + 1}. API ${api.name}`}</p>
  ));
}

export function renderApiDetails(list, field, limit) {
  return list.map((api, i) => (
    <p
      style={{ height: "45px", textOverflow: "ellipsis", overflow: "hidden" }}
      key={api.name}
    >{`${api[field]}/${api[limit] ? api[limit] : "∞"}`}</p>
  ));
}

export const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;



// WEBPACK FOOTER //
// ./app/components/Integrators/utils.js